import PageIndex from '../components/views/Index'
import PageTerms from '../components/views/Terms'
import PageBooking from '../components/views/Booking'
import PageNotFound from '../components/views/NotFound'

const routes = [
    {
        path: '/',
        name: 'index',
        component: PageIndex,
        alias: '/:locale'
    },
    {
        path: '/:locale/terms',
        name: 'terms',
        component: PageTerms
    },
    {
        path: '/:locale/booking',
        name: 'booking',
        component: PageBooking
    },
    {
        path: '/:locale/*',
        name: 'not-found',
        component: PageNotFound,
        alias: '/:locale/404'
    }
]

export { routes }
